import { Divider, List } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoListItem } from '~/components/MyWorkspace/InfoListItem';
import { People } from '~/services/Http';
import { useGetTaskComments } from '~/services/Http/hooks';

import { getMomentOfChange } from '../../services';

import { useSxStyles } from './useStyles';

export interface Props {
  listItem: People.TaskDto;
}

export const TaskInfo: React.FC<Props> = ({ listItem }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  const getTaskCommentsReqParams = {
    taskId: listItem.id,
  };
  const { data: comments } = useGetTaskComments(getTaskCommentsReqParams);

  return (
    <List disablePadding={true} sx={sxStyles.listRoot}>
      <InfoListItem
        primaryText={`${t('title')}:`}
        secondaryText={listItem.title}
        customSxStyles={{ primaryText: sxStyles.primaryText }}
        primaryTypographyProps={{
          variant: 'body2',
          display: 'inline',
        }}
        secondaryTypographyProps={{
          display: 'inline',
        }}
      />
      {listItem.description && (
        <InfoListItem
          primaryText={`${t('description')}:`}
          secondaryText={listItem.description}
          customSxStyles={{ primaryText: sxStyles.primaryText }}
          primaryTypographyProps={{
            variant: 'body2',
            display: 'inline',
          }}
          secondaryTypographyProps={{
            display: 'inline',
          }}
        />
      )}
      <InfoListItem
        primaryText={`${t('type')}:`}
        secondaryText={listItem.type.value}
        customSxStyles={{ primaryText: sxStyles.primaryText }}
        primaryTypographyProps={{
          variant: 'body2',
          display: 'inline',
        }}
        secondaryTypographyProps={{
          display: 'inline',
        }}
      />
      {listItem.status && (
        <InfoListItem
          primaryText={`${t('status')}:`}
          secondaryText={listItem.status.value}
          customSxStyles={{ primaryText: sxStyles.primaryText }}
          primaryTypographyProps={{
            variant: 'body2',
            display: 'inline',
          }}
          secondaryTypographyProps={{
            display: 'inline',
          }}
        />
      )}
      <InfoListItem
        primaryText={`${t('startDate')}:`}
        secondaryText={moment(listItem.startDate).format('L')}
        customSxStyles={{ primaryText: sxStyles.primaryText }}
        primaryTypographyProps={{
          variant: 'body2',
          display: 'inline',
        }}
        secondaryTypographyProps={{
          display: 'inline',
        }}
      />
      {listItem.dueDate && (
        <InfoListItem
          primaryText={`${t('endDate')}:`}
          secondaryText={moment(listItem.dueDate).format('L')}
          customSxStyles={{ primaryText: sxStyles.primaryText }}
          primaryTypographyProps={{
            variant: 'body2',
            display: 'inline',
          }}
          secondaryTypographyProps={{
            display: 'inline',
          }}
        />
      )}
      {listItem.assignee && (
        <InfoListItem
          primaryText={`${t('assignee')}:`}
          secondaryText={`${listItem.assignee.firstName} ${listItem.assignee.lastName}`}
          customSxStyles={{ primaryText: sxStyles.primaryText }}
          primaryTypographyProps={{
            variant: 'body2',
            display: 'inline',
          }}
          secondaryTypographyProps={{
            display: 'inline',
          }}
        />
      )}
      {listItem.pertainingTo && (
        <InfoListItem
          primaryText={`${t('pertainingTo')}:`}
          secondaryText={`${listItem.pertainingTo.firstName} ${listItem.pertainingTo.lastName}`}
          customSxStyles={{ primaryText: sxStyles.primaryText }}
          primaryTypographyProps={{
            variant: 'body2',
            display: 'inline',
          }}
          secondaryTypographyProps={{
            display: 'inline',
          }}
        />
      )}
      {/*To add this field when we have BE, so it would be clear how to download on click.*/}
      {/* {task.attachment && (
        <InfoListItem
          primaryText={`${t('attachement')}:`}
          secondaryText={task.attachment}
          classes={infoListItemClasses}
          primaryTypographyProps={{
            variant: 'body2',
            display: 'inline',
          }}
          secondaryTypographyProps={{
            display: 'inline',
          }}
        />
      )} */}
      <Divider sx={sxStyles.divider} />
      {listItem.updatedBy && (
        <InfoListItem
          primaryText={''}
          secondaryText={`
              ${getMomentOfChange(listItem.updatedAt, t)}  ${t('updatedBy')} ${
            listItem.updatedBy.firstName
          } ${listItem.updatedBy.lastName}`}
          customSxStyles={{
            listItemTextMultiline: sxStyles.listItemTextMultiline,
          }}
        />
      )}
      <InfoListItem
        primaryText={''}
        secondaryText={`
          ${getMomentOfChange(listItem.createdAt, t)} ${t('createdBy')} ${
          listItem.assignor.firstName
        } ${listItem.assignor.lastName}`}
        customSxStyles={{
          listItemTextMultiline: sxStyles.listItemTextMultiline,
        }}
      />
      {!!comments?.length && (
        <>
          <Divider sx={sxStyles.divider} />
          <InfoListItem
            primaryText={`${t('comments')}:`}
            secondaryText={comments ? comments.length.toString() : '0'}
            customSxStyles={{ primaryText: sxStyles.primaryText }}
            primaryTypographyProps={{
              variant: 'body2',
              display: 'inline',
            }}
            secondaryTypographyProps={{
              display: 'inline',
            }}
          />

          {comments.map((comment, index) => (
            <InfoListItem
              key={`comment - ${index}`}
              primaryText={''}
              secondaryText={comment.comment}
              customSxStyles={{
                listItemTextMultiline: sxStyles.listItemTextMultiline,
              }}
            />
          ))}
        </>
      )}
    </List>
  );
};
